
export var config = {
    serverUrl : "https://sutc.studentscenter.in",    
    socketioUrl : "http://localhost:2",
    ENV_sendgrid_Twilio : "production",
    markListUploadUrl : "https://sutc.studentscenter.in/api/attestation/uploadMarkList",
    transUploadUrl:"https://sutc.studentscenter.in/api/attestation/upload_transcript",
    curriculumUploadUrl: "https://sutc.studentscenter.in/api/attestation/upload_curriculum",
    docUploadUrl :  "https://sutc.studentscenter.in/api/etranscript/upload_doc",
    production: true,
    emailIdOperational :'su.sfc@studentscenter.in',
    numberOperational :'9702301302',
    Property : '',
    imageUrl: '',
    alt_address: '',
  }
  